/**
 * ID de l'arrêt obligatoire à insérer entre les arrêts lorsque nécessaire
 * Cet id correspond à Annecy
 */
const REQUIRED_STOP_ID = "3";

/**
 * Ajoute des arrêts obligatoires entre les arrêts d'une séquence lorsque nécessaire.
 * Un arrêt obligatoire est inséré lorsque l'ID de l'arrêt suivant est inférieur ou égal
 * à l'ID de l'arrêt actuel, et que ni l'arrêt actuel ni l'arrêt suivant ne sont déjà
 * l'arrêt obligatoire.
 *
 * @param currentStops - Tableau d'IDs d'arrêts à traiter
 * @returns Nouveau tableau d'IDs d'arrêts avec les arrêts obligatoires insérés
 *
 * @example
 * addRequiredStops(["8", "5"])
 * // Retourne ["8", "3", "5"]
 *
 */
export function addRequiredStops(currentStops: string[]): string[] {
    return currentStops.reduce<string[]>((acc, current, index) => {
        acc.push(current);

        const next = currentStops[index + 1];
        const shouldInsertStop =
            next !== undefined &&
            next !== "" &&
            Number(current) >= Number(next) &&
            acc[acc.length - 1] !== REQUIRED_STOP_ID &&
            next !== REQUIRED_STOP_ID;

        if (shouldInsertStop) {
            acc.push(REQUIRED_STOP_ID);
        }

        return acc;
    }, []);
}
